export default __webpack_public_path__ + "static/media/kissmetrics.32fb7484.svg";